import { I18nComponente } from "@/types/gerais"

export const MMultiSelecti18n: I18nComponente = {
  "pt-BR": {
    buscarPorNome: "buscar por nome",
    itensSelecionados: "itens selecionados",
  },
  "es-CO": {
    buscarPorNome: "buscar por nombre",
    itensSelecionados: "elementos seleccionados",
  }
}
